import {apiBaseUrl} from './settings'

export function makeApiFilterUrl (slug, filters = null) {
  let queryUrl = apiBaseUrl[process.env.NODE_ENV] + slug + '?'

  if (filters !== null) {
    if (filters.startDate) {
      queryUrl += 'start_date=' + filters.startDate + '&'
    }

    if (filters.endDate) {
      queryUrl += 'end_date=' + filters.endDate + '&'
    }

    if (filters.map) {
      if (filters.map.active === 1) {
        queryUrl += 'ne=' + filters.map.bounds.ne.lat + ',' + filters.map.bounds.ne.lng + '&' +
                    'sw=' + filters.map.bounds.sw.lat + ',' + filters.map.bounds.sw.lng + '&'
      }
    }

    if (filters.params) {
      queryUrl += filters.params
    }
  }

  return queryUrl
}

export function makeApiUrl (slug) {
  return apiBaseUrl[process.env.NODE_ENV] + slug
}

export function makeGetByIdUrl (slug, ids) {
  return apiBaseUrl[process.env.NODE_ENV] + slug + '?ids=' + ids
}

export function makeAutocompleteUrl (slug, terms) {
  return apiBaseUrl[process.env.NODE_ENV] + slug + '?terms=' + terms
}



// WEBPACK FOOTER //
// ./src/vuex/util.js